/* eslint-disable import/no-anonymous-default-export */
import global from "./global.json"

export default {
  global,
}
